import { connect } from "react-redux";
import { sessionSlice } from "../../store/sessionSlice";
import Menu from "../components/Menu";

const mapStateToProps = (state) => {
  return {
    sessionType: state.session.sessionType,
    isShowingInfoModal: state.session.isShowingInfoModal,
    engine: state.session.engine,
    isLlmActive: state.session.isLlmActive,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onToggleInfoModal: () => {
      dispatch(sessionSlice.actions.toggleInfoModal());
    },
  };
};

export const MenuContainer = connect(mapStateToProps, mapDispatchToProps)(Menu);
